import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Small "Retour" pill button. Shows on every page except the home page.
 * Uses browser history when available, otherwise falls back to "/".
 */
export default function BackButton({ className = "" }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (pathname === "/") return null;

  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/");
  };

  return (
    <button
      onClick={goBack}
      className={`fixed top-20 left-4 z-30 inline-flex items-center gap-1.5 rounded-full bg-white border border-gray-200 px-3 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:border-[var(--sl-primary)] hover:text-[var(--sl-primary)] transition ${className}`}
      data-testid="back-button"
      aria-label="Retour"
    >
      <ArrowLeft size={13} /> Retour
    </button>
  );
}
